import { PromoPhase } from '../use-ai-promo';
import { HStack } from 'components';
import { Alert, Button } from 'components/ui';

type AiPromoActionsProps = {
  phase: PromoPhase;
  onClose: () => void;
  onSubmit: () => void;
};
export const AiPromoActions = (props: AiPromoActionsProps) => {
  const { phase, onClose, onSubmit } = props;

  if (phase.status === 'submitted') {
    return <Alert mode="info" description={phase.alert} withIcon={false} />;
  }

  return (
    <HStack justify="flex-end" spacing="xs">
      <Button mode="neutral" onClick={onClose}>
        Закрыть
      </Button>
      <Button
        mode="accent"
        pending={phase.status === 'submitting'}
        onClick={onSubmit}
      >
        Отправить запрос
      </Button>
    </HStack>
  );
};
